/**
 * QuantiyButton Component
 * expects a wrapper element
 * requires element to have three defined data elements
 * for increase and decrease buttons and the quantitiy input
 * Dispatches an event for use in cart
 **/

import eventBus from "../../../core/services/event-bus";
import elementExists from "../../../core/utils/element-exists";
import debounce from "../../../core/utils/debounce";

const QuantityComponent = function (component) {
  const defaults = { minValue: 0, maxValue: 1000 }
  let timeout = false

  let data = component.dataSet
  data = Object.assign(defaults, data)

  const lineItem = component.closest("[data-cart-item]")
  const itemsPerCase = parseInt(lineItem.dataset.itemsPerCase) || 0

  const quantityControls = Array.from(
    component.querySelectorAll("[data-quantity-control]")
  )

  const countCase = component.querySelector("[data-count-case]")
  const countItem = component.querySelector("[data-count-item]")

  const subtotalContainer = document.querySelector("[data-cart-subtotal]")

  const elementsExist =
    quantityControls.length > 0 &&
    elementExists(countCase) &&
    elementExists(countItem) &&
    elementExists(subtotalContainer)
      ? true
      : false

  const removeListeners = () => {
    quantityControls.forEach((el) => {
      el.removeEventListener("click", () => {})
    })
  }

  const updateItemQuantity = (action) => {
    clearTimeout(timeout)

    let count = parseInt(countCase.value)

    switch (action) {
      case "plus":
        if (count == data.maxValue) return
        count += 1
        break
      case "minus":
        if (count == data.minValue) return
        count -= 1
        break
      default:
        console.log("no action")
    }

    countCase.value = count
    updateHiddenField(count)
  };

  const updateHiddenField = (count) => {
    let updatedCount

    if (itemsPerCase > 0) {
      countItem.value = count * itemsPerCase
      updatedCount = count * itemsPerCase
    } else {
      countItem.value = count
      updatedCount = count
    }
    
    timeout = setTimeout(function () {
      document.dispatchEvent(
        new CustomEvent('BundleCartQuantityChanged', {
          detail: {
            target: lineItem,
            value: updatedCount,
          }
        })
      )},250)
  }

  const submitKeyUp = function () {
    let count = parseInt(countCase.value);
    if (isNaN(count) == false) {
      updateHiddenField(count)
    }
  }

  const initQuantityInput = () => {
    removeListeners()

    quantityControls.forEach((el) => {
      const action = el.dataset.quantityControl;

      el.addEventListener("click", () => {
        updateItemQuantity(action)
      })
    })

    countCase.addEventListener("keyup", debounce(submitKeyUp, 500));
  }

  initQuantityInput()
}

export default QuantityComponent;
